import { FC, memo } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { Card } from 'components/card'
import { Grid, Col } from 'components/grid'
import { BikeIcon, CarIcon, TruckIcon } from 'components/new-icons'

import * as S from './styles'

interface PageProps {
  onClick: () => void
}

const ConsortiumTypes: FC<PageProps> = memo(({ onClick: handleMoreInfo }) => (
  <S.Wrapper>
    <Grid col={{ phone: 1, tablet: 12, desktop: 12 }}>
      <Col col={{ tablet: 10, desktop: 10 }} start={{ tablet: 2, desktop: 2 }}>
        <Text as="h2" size="heading2" weight="medium">
          <Text as="span" size="heading2" weight="medium" color="var(--colors-pink-text-default)">
            Que tipo de bens
          </Text>{' '}
          posso conquistar com o Consórcio de Veículos CashMe?
        </Text>
        <S.CardsWrapper>
          <Card border="neutral-border-default">
            <S.CardContent>
              <CarIcon color="#1854FF" />
              <Text as="h3" size="heading4" weight="medium" color="var(--neutral-text-default)">
                Carros
              </Text>
              <ul>
                <li>
                  <Text size="body1" color="var(--colors-neutral-text-weak)">
                    Carta de crédito: de R$40 mil a R$440 mil
                  </Text>
                </li>
                <li>
                  <Text size="body1" color="var(--colors-neutral-text-weak)">
                    Prazos: Até 96 meses
                  </Text>
                </li>
                <li>
                  <Text size="body1" color="var(--colors-neutral-text-weak)">
                    Tipo: 0 KM ou 10 anos de uso
                  </Text>
                </li>
              </ul>
              <Button onClick={handleMoreInfo}>Saiba mais</Button>
            </S.CardContent>
          </Card>
          <Card border="neutral-border-default">
            <S.CardContent>
              <BikeIcon color="#1854FF" />
              <Text as="h3" size="heading4" weight="medium" color="var(--neutral-text-default)">
                Motos
              </Text>
              <ul>
                <li>
                  <Text size="body1" color="var(--colors-neutral-text-weak)">
                    Carta de crédito: de R$10 mil a R$27 mil
                  </Text>
                </li>
                <li>
                  <Text size="body1" color="var(--colors-neutral-text-weak)">
                    Prazos: Até 60 meses
                  </Text>
                </li>
                <li>
                  <Text size="body1" color="var(--colors-neutral-text-weak)">
                    Tipo: 0 KM
                  </Text>
                </li>
              </ul>
              <Button onClick={handleMoreInfo}>Saiba mais</Button>
            </S.CardContent>
          </Card>
          <Card border="neutral-border-default">
            <S.CardContent>
              <TruckIcon color="#1854FF" />
              <Text as="h3" size="heading4" weight="medium" color="var(--neutral-text-default)">
                Pesados
              </Text>
              <ul>
                <li>
                  <Text size="body1" color="var(--colors-neutral-text-weak)">
                    Carta de crédito: de R$130 mil a R$1,2 milhão
                  </Text>
                </li>
                <li>
                  <Text size="body1" color="var(--colors-neutral-text-weak)">
                    Prazos: Até 120 meses
                  </Text>
                </li>
                <li>
                  <Text size="body1" color="var(--colors-neutral-text-weak)">
                    Tipo: 0 KM ou 7 anos de uso
                  </Text>
                </li>
              </ul>
              <Button onClick={handleMoreInfo}>Saiba mais</Button>
            </S.CardContent>
          </Card>
        </S.CardsWrapper>
      </Col>
    </Grid>
  </S.Wrapper>
))

ConsortiumTypes.displayName = 'ConsortiumTypes'

export default ConsortiumTypes
